<template>
  <v-btn
    :color="theme.color"
    :variant="theme.outline ? 'outlined' : 'elevated'"
    :loading="ui.loading && !((cancel || close) && ui.loading)"
    :disabled="disabled || ((cancel || close) && ui.loading)"
    :size="small ? 'small' : size"
    rounded="xs"
    density="compact"
    @click.stop="$emit('click')"
  >
    {{ _label }}
  </v-btn>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      login: Boolean,
      ok: Boolean,
      cancel: Boolean,
      submit: Boolean,
      save: Boolean,
      apply: Boolean,
      delete: Boolean,
      close: Boolean,
      color: {
        type: String,
        default: ''
      },
      small: Boolean,
      size: {
        default: 'large',
        type: String
      }
    },
    emits: ['click'],
    data: () => ({
      loading: false,
      disabled: false
    }),
    computed: {
      ...mapGetters(['ui']),
      theme () {
        if (this.cancel || this.close) {
          return { color: 'grey darken-1', outline: true }
        } else if (this.delete) {
          return { color: 'red white--text' }
        } else if (this.color) {
          return { color: this.color }
        } else {
          return { color: 'secondary' }
        }
      },
      _label () {
        if (this.login) {
          return this.$t('User.Login')
        } else if (this.ok) {
          return 'OK'
        } else if (this.cancel) {
          return this.$t('Cancel')
        } else if (this.submit) {
          return this.$t('Submit')
        } else if (this.save) {
          return this.$t('Save')
        } else if (this.apply) {
          return this.$t('Apply')
        } else if (this.delete) {
          return this.$t('Delete')
        } else if (this.close) {
          return this.$t('Close')
        } else {
          return this.label
        }
      }
    },
    watch: {
      '$store.getters.ui.loading' () {
        if (this.login || this.submit || this.ok || this.save || this.apply) {
          this.loading = this.$store.getters.ui.loading
        } else {
          this.disabled = this.$store.getters.ui.loading
        }
      }
    }
  }
</script>

